import { Component, inject, OnInit, signal } from '@angular/core';
import { ParameterService, PaymentService, SpinnerComponent } from "@frontend/frontendlib";

@Component({
  selector: 'app-checksuccess',
  standalone: true,
  imports: [SpinnerComponent ],
  templateUrl: './checksuccess.component.html',
  styleUrl: './checksuccess.component.css',
})
export class ChecksuccessComponent implements OnInit {
  loading = signal(false);
  paymentService = inject(PaymentService);
  parameterService = inject(ParameterService);
  success = signal(false);

  ngOnInit(): void {
    this.checkParameter();
  }

  checkParameter() {
    this.loading.set(true);
    this.paymentService
      .checkSuccess(
        this.parameterService.queryParams.channel_id,
        this.parameterService.queryParams.payment_id ?? '',
        this.parameterService.queryParams.seccode ?? ''
      )
      .subscribe((val) => {
        this.success.set(val.success);
        this.loading.set(false);
        if (this.success()) {
          window.location.assign(
            `${this.paymentService.origin}?channel=${this.parameterService.queryParams.channel_id}&payment=${this.parameterService.queryParams.payment_id}&seccode=${this.parameterService.queryParams.seccode}`
          );
        }
      });
  }
}
